import { createAction, props } from '@ngrx/store';

import { LoginMethod } from '@personal-area/global/authorization/models';
import { DataLayer } from '@personal-area/global/gtm';

export const SET_LOGIN_METHOD = '[Login Analytics] Set login method';
export const SET_USER_DATA = '[Login Analytics] Set user data';
export const SET_IS_LOGIN_AFTER_REGISTRATION =
  '[Login Analytics] Set the status of the current login';
export const SET_EVENT_DISPATCH_STATUS =
  '[Login Analytics] Set the flag for dispatch status';

export const SetUserData = createAction(
  SET_USER_DATA,
  props<{ user: DataLayer['user'] }>(),
);
export const SetIsLoginAfterRegistration = createAction(
  SET_IS_LOGIN_AFTER_REGISTRATION,
  props<{ isLoginAfterRegistration: boolean }>(),
);
export const SetLoginMethod = createAction(
  SET_LOGIN_METHOD,
  props<{ method: LoginMethod }>(),
);
export const SetEventDispatchStatus = createAction(
  SET_EVENT_DISPATCH_STATUS,
  props<{ isEventSent: boolean }>(),
);
